import React, { useEffect, useState } from 'react';
import { useError } from '../hooks/useError';
import { Notification } from '~/shared/components/Notifications';
import { useTranslation } from '~/shared/utils/translation';
import { StyledContent } from './styled';
import { theme } from '~/theme';

type Props = {
    description?: string;
};

export const ErrorBoundaryFallback = ({ description }: Props) => {
    const { error } = useError();
    const { translate } = useTranslation();
    const [dismiss, setDismiss] = useState(false);

    useEffect(() => {
        console.info(`%${error?.message}`, `color: ${theme.colors.redMedium}`);
    }, []);

    return (
        <>
            {!dismiss && (
                <StyledContent>
                    <Notification
                        onDismiss={() => setDismiss(true)}
                        text={description || translate('message.contentUnavailable')}
                        duration={0}
                    />
                </StyledContent>
            )}
        </>
    );
};
